// 导入安装的axios
import axios from 'axios'

// 创建axios请求实例,并暴
const myaxios = axios.create({
    // baseURL: 'http://easygzh.natapp1.cc/houduan',
    // baseURL: 'http://192.168.1.36:8080',  // 开发时直连后端(不走代理/nginx)
    // baseURL: 'https://revit.swwps.cn/swwp',
    // baseURL: 'https://cad.swwps.cn/swwp',
    // baseURL: 'https://cad.9jtx.cn/swwp',
    // 相对路径: 跟随当前页面域名, 生产走nginx /swwp/ 转后端, 开发走vue devServer代理转后端
    baseURL: '/swwp',
    // baseURL: 'https://www.swwps.cn/swwp',
    timeout: 500000,
    headers: { 'X-Custom-Header': 'foobar' }
});

// 请求拦截器: 自动带上登录后保存的管理员token
myaxios.interceptors.request.use(config => {
    try {
        const dengru = window.localStorage.getItem("dengru");
        if (dengru) {
            const u = JSON.parse(dengru);
            if (u && u.token) {
                config.headers['token'] = u.token;
            }
        }
    } catch (e) {
        // 解析失败忽略
    }
    return config;
});

// 响应拦截器: token过期/未登录时清空本地登录信息并跳回登录页
myaxios.interceptors.response.use(res => {
    try {
        if (res && res.data && res.data.code === -1000
            && res.data.message
            && res.data.message.indexOf("未登录") !== -1
            && res.config.url && res.config.url.indexOf("/login/") === -1) {
            window.localStorage.removeItem("dengru");
            // 清空登录态后刷新页面, 由路由守卫统一跳回登录页(history模式下直接改hash不可靠)
            window.location.reload();
        }
    } catch (e) {
        // 忽略
    }
    return res;
});

//暴露接口
export default myaxios;
